/**
 * The unique half of a tag - a control network's, a team's, a deploy
 * marker's. Minted here rather than in the engine, which does not reach
 * for randomness (gotcha #5). `crypto.randomUUID` is in every browser this
 * app supports and in jsdom; the fallback keeps a test environment without
 * it from throwing rather than from being unique.
 */
export function mintUnique(): string {
  const uuid = globalThis.crypto?.randomUUID?.();
  return (uuid || String(Date.now())).slice(0, 8);
}

/** A document id that sorts by when it was made and never collides: `f-mgx2k1-3fa9c2d1`. No Math.random (gotcha 5). */
export function mintId(prefix: string): string {
  return `${prefix}-${Date.now().toString(36)}-${mintUnique()}`;
}
